import React from "react";
import LoadFinishedGeneral from "components/MainApp/organisms/LoadFinishedGeneral"
import CredentialBoxes from "../CredentialsBoxes";

import styles from "./AppAddSuccess.module.scss";
import i18n from "i18n";

 const AppAddSuccess = ({app, boldButtonFunc}) => {
    return (
      <LoadFinishedGeneral
        title={i18n.t("registered.application")}
        boldButtonLabel={i18n.t("register.new.application")}
        buttonLabel={i18n.t("see.list.applications")}
        boldButtonLink={"/admin/applications/add"}
        buttonLink={`/admin/applications`}
        boldButtonFunc={boldButtonFunc}
      > 
        <div className={styles["app-add-success-container"]}>
          <div className={styles["subtitle"]}>{i18n.t("application.created.successfully")}</div>
          <div className={styles["credentials-title"]}>{i18n.t("production.credentials")}</div>
          <CredentialBoxes app={app}></CredentialBoxes>
        </div>
      </LoadFinishedGeneral>
    )
  
}

export default AppAddSuccess;